<template>
	<div class="pd-nav">
		<a class="pd-nav__brand" :href="home">
			<img src="/assets/palbon_docs/images/palbon-docs-mark.svg" alt="" width="28" height="28" />
			<span>PALBON <b>Docs</b></span>
		</a>
		<label class="pd-filter">
			<span class="pd-visually-hidden">{{ t("Filter the sections") }}</span>
			<input v-model="filter" type="search" :placeholder="t('Filter sections and pages')" autocomplete="off" />
		</label>
		<ul class="pd-nav__list">
			<li v-for="item in visible" :key="item.route" class="pd-nav__section" :class="{ 'is-open': isOpen(item), 'is-current': item.route === section }">
				<button type="button" class="pd-nav__toggle" :aria-expanded="isOpen(item)" @click="toggle(item)">
					<span>{{ item.title }}</span>
					<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path d="m9 6 6 6-6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /></svg>
				</button>
				<div v-show="isOpen(item)" class="pd-nav__groups">
					<a class="pd-nav__overview" :class="{ 'is-active': current === item.route }" :href="item.route" @click="$emit('navigate')">{{ t("Overview") }}</a>
					<template v-for="(group, index) in item.groups" :key="index">
						<p v-if="group.title" class="pd-nav__group">{{ group.title }}</p>
						<a
							v-for="page in group.pages"
							:key="page.route"
							:href="page.route"
							:class="{ 'is-active': current === page.route }"
							:aria-current="current === page.route ? 'page' : null"
							@click="$emit('navigate')"
						>{{ page.title }}</a>
					</template>
				</div>
			</li>
		</ul>
	</div>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";

const props = defineProps({
	tree: { type: Array, required: true },
	current: { type: String, default: "" },
	section: { type: String, default: null },
	home: { type: String, default: "/user-manual" },
});
defineEmits(["navigate"]);
const t = (text) => (window.__ ? window.__(text) : text);
const filter = ref("");
const opened = ref(new Set(props.section ? [props.section] : []));

// While filtering, every section with a match opens and shows only its matching pages.
const visible = computed(() => {
	const query = filter.value.trim().toLowerCase();
	if (!query) return props.tree;
	return props.tree
		.map((s) => {
			const groups = s.groups
				.map((g) => ({ ...g, pages: g.pages.filter((p) => p.title.toLowerCase().includes(query)) }))
				.filter((g) => g.pages.length);
			return s.title.toLowerCase().includes(query) ? s : groups.length ? { ...s, groups } : null;
		})
		.filter(Boolean);
});

const isOpen = (item) => Boolean(filter.value.trim()) || opened.value.has(item.route);
function toggle(item) {
	const next = new Set(opened.value);
	next.has(item.route) ? next.delete(item.route) : next.add(item.route);
	opened.value = next;
}

onMounted(() => {
	const active = document.querySelector(".pd-nav a.is-active");
	if (active) active.scrollIntoView({ block: "center" });
});
</script>
